<opac-dialog [size]="'medium'" [title]="'recaptcha.dialog.title' | translate" (closed)="closeDialog()">
  <section>
    <p>{{ 'recaptcha.dialog.message' | translate }}</p>

    <re-captcha
      *ngIf="isOpen()"
      #captcha="reCaptcha"
      (resolved)="$event && resolved.emit($event)"
      (errored)="handleError()"
      errorMode="handled"
    ></re-captcha>
  </section>

  <div slot="actions">
    <opac-button type="tertiary" (click)="closeDialog()">{{ 'general.cancel' | translate }}</opac-button>
  </div>
</opac-dialog>
